import { Box, createStyles, makeStyles, styled, Typography } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: 'flex',
      // flexDirection: 'column',
      overflow: 'hidden',
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column-reverse',
      },
    },

    left: {
      borderBottomLeftRadius: 8,
      borderTopLeftRadius: 8,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      // background: '#10151c',s
      // minWidth: 206,

      '& .MuiSvgIcon-root': {
        marginBottom: 5,
        // '& path': {
        //   fill: '#e53737',
        // },
      },
    },

    right: {
      justifyContent: 'center',
      borderTopLeftRadius: 8,
      padding: 30,
      display: 'flex',
      alignItems: 'center',
      [theme.breakpoints.down(600)]: {
        borderBottom: '1px solid #2d343e',
        borderLeft: '1px solid #2d343e',
      },
    },
  }),
);

export const TimeDivision = styled(Box)(({ theme }) => ({
  display: 'flex',
  height: '100%',
  width: '100%',
  [theme.breakpoints.down(960)]: {
    flexDirection: 'column',
  },
}));

export const TimeBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  // borderRight: `1px solid ${COLORS.GRAY}`,
  justifyContent: 'center',
}));
